import {message} from "antd";
import  AgencyMaintainService from "../../agency_maintain/service";

export const SYS_MGT_USER_LIST = "SYS_MGT_USER_LIST"; // 用户列表
export const SYS_MGT_USER_LIST_IS_LOADING = "SYS_MGT_USER_LIST_IS_LOADING"; // 加载中
export const SYS_MGT_USER_MODAL = "SYS_MGT_USER_MODAL"; // 设置模态框信息
export const SYS_MGT_USER_MODAL_IS_LOADING = "SYS_MGT_USER_MODAL_IS_LOADING"; // 模态框是否正在提交中
export const SYS_MGT_USER_EDIT_USER = "SYS_MGT_USER_EDIT_USER"; // 编辑用户
export const SYS_MGT_DEPT_SET_SEARCH_PARAMS = "SYS_MGT_DEPT_SET_SEARCH_PARAMS"; // 设置查询参数
export const SYS_MGT_USER_RESET_PASSWORD_MODAL = "SYS_MGT_USER_RESET_PASSWORD_MODAL"; // 重置密码模态框信息
export const SYS_MGT_USER_RESET_PASSWORD_MODAL_IS_LOADING = "SYS_MGT_USER_RESET_PASSWORD_MODAL_IS_LOADING"; // 重置密码模态框是否loading
/**
 * 获取用户列表
 */
export const getUserList = (searchParam) => {
    return dispatch => {
        dispatch(setIsLoading(true));
        AgencyMaintainService.sysMgtUserService.getUserList(searchParam).then(json => {
            if(json.code == 0){
                dispatch({
                    type: SYS_MGT_USER_LIST,
                    userList: json.data.pageList,
                    totalCount: json.data.totalCount
                })
            }else{
                message.error(json.msg)
            }
        }).catch(e => {
            console.error("获取用户列表失败:" + e);
            message.error("获取失败");
        }).then(() => dispatch(setIsLoading(false)))
    }
}

/**
 * 设置列表是否加载中
 * @param isLoading bool true: 是 false:否
 */
const setIsLoading = (isLoading) => {
    return {
        type: SYS_MGT_USER_LIST_IS_LOADING,
        isLoading: isLoading
    }
}

/**
 * 设置模态框信息
 */
export const setUserModal = (userModal) => {
    return {
        type: SYS_MGT_USER_MODAL,
        userModal: userModal
    }
}

/**
 * 新增用户
 * @param userInfo 用户信息
 */
export const addUser = (userInfo) => {
    return (dispatch, getState) => {
        dispatch(setModalLoading(true));
        AgencyMaintainService.sysMgtUserService.addUser(userInfo).then(json => {
            dispatch(setModalLoading(false));
            if(json.code == 0){
                message.success("新增成功");
                dispatch(setUserModal({visible: false}))
                // 获取查询参数，刷新查询列表
                const searchParams = getState().agencyMaintainData.userData.searchParams;
                dispatch(getUserList(searchParams))
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("新增用户异常:" + e);
            message.error("新增失败");
        })
    }
}

/**
 * 设置模态框是否加载中
 * @param isLoading
 * @returns {{isLoading: *, type: *}}
 */
const setModalLoading = (isLoading) => {
    return ({
        type: SYS_MGT_USER_MODAL_IS_LOADING,
        isLoading: isLoading
    })
}

/**
 * 删除用户
 * @param userId 用户id
 */
export const deleteUser = (userNo) => {
    return (dispatch, getState) => {
        message.loading({content: "删除中...", key: userNo, duration: 0});
        AgencyMaintainService.sysMgtUserService.deleteUser(userNo).then(json => {
            if(json.code == 0){
                message.success({content: "删除成功", key: userNo});
                // 刷新查询列表
                const searchParams = getState().agencyMaintainData.userData.searchParams
                dispatch(getUserList(searchParams))
            }else{
                message.error({content: json.msg, key: userNo});
            }
        }).catch(e => {
            console.error("删除用户异常:" + e);
            message.error({content: "删除失败", key: userNo});
        })
    }
}

/**
 * 编辑用户
 * @param userInfo 用户信息
 */
export const editUser = (userInfo) => {
    return (dispatch) => {
        dispatch(setModalLoading(true));
        AgencyMaintainService.sysMgtUserService.editUser(userInfo).then(json => {
            dispatch(setModalLoading(false));
            if(json.code == 0){
                dispatch({
                    type: SYS_MGT_USER_EDIT_USER,
                    userInfo: json.data
                })
                dispatch(setUserModal({visible: false}))
                message.success("修改成功");
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("编辑用户异常:" + e);
            message.error("修改失败");
        })
    }
}
/**
 * 重置密码
 * @param userNo 用户编号
 * @param password 密码
 */
export const resetPassword = (userNo, password) => {
    return dispatch => {
        dispatch(setResetPasswordModal({isLoading: true}));
        AgencyMaintainService.sysMgtUserService.resetPassword(userNo, password).then(json => {
            if(json.code == 0){
                dispatch(setResetPasswordModal({visible: false}))
                message.success("修改成功");
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("修改密码异常:" + e);
            message.error("修改密码失败");
        }).then(() => dispatch(setResetPasswordModal({isLoading: false})))
    }
}

/**
 * 设置查询参数
 * @param searchParams 查询参数
 */
export const setSearchParams = (searchParams) => {
    return {
        type: SYS_MGT_DEPT_SET_SEARCH_PARAMS,
        searchParams: searchParams
    }
}

/**
 * 设置重置密码模态框是否可见
 */
export const setResetPasswordModal = (data) => {
    return {
        type: SYS_MGT_USER_RESET_PASSWORD_MODAL,
        data: data
    }
}

/**
 * 设置重置密码模态框是否加载中
 */
export const setResetPasswordModalIsLoading = (isLoading) => {
    return {
        type: SYS_MGT_USER_RESET_PASSWORD_MODAL_IS_LOADING,
        isLoading: isLoading
    }
}
